import { Getter } from 'vuex';
import StepsState from '@/types/store/StepsState';
import RootState from '@/types/store/RootState';

const selectedCommune: Getter<StepsState, RootState> = (state, getters) => {
  return getters.stepValuesById('commune');
};
export default selectedCommune;
